<app-auth-card
  [loader]="resetEmailComponentLoader"
  [title]="'auth.resetEmail.title' | translate"
  [description]="'auth.resetEmail.description' | translate"
>
  <form [formGroup]="editForm" (ngSubmit)="onSubmit()" class="grid grid-cols-1 gap-4">
    <div>
      <label
        [appRequiredLabel]="editForm.controls.token"
        for="token"
        class="block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2"
        >{{ 'auth.resetEmail.verificationCode' | translate }}</label
      >
      <input
        pInputText
        id="token"
        type="text"
        autocomplete="one-time-code"
        class="w-full"
        formControlName="token"
        [placeholder]="'auth.resetEmail.verificationCode' | translate"
      />
      <app-form-error [control]="editForm.controls.token" />
    </div>

    <div>
      <label
        [appRequiredLabel]="editForm.controls.password"
        for="password"
        class="block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2"
        >{{ 'auth.resetEmail.password' | translate }}</label
      >
      <p-password
        inputId="password"
        formControlName="password"
        autocomplete="current-password"
        [placeholder]="'auth.resetEmail.password' | translate"
        [toggleMask]="true"
        [feedback]="false"
        [fluid]="true"
      />
      <app-form-error [control]="editForm.controls.password" />
    </div>

    <p-button
      type="submit"
      [label]="'auth.resetEmail.save' | translate"
      icon="pi pi-check"
      size="large"
      styleClass="w-full"
    />
  </form>

  <div class="mt-6 text-center">
    <a [routerLink]="['/auth/login']" class="text-primary font-medium no-underline hover:underline">
      {{ 'auth.layout.backToLogin' | translate }}
    </a>
  </div>
</app-auth-card>
